import styled, { css } from 'styled-components';

import COLORS from 'styles/colors';
import TYPO from 'styles/typography';

const ContainerSticky = styled.ul`
  position: sticky;
  top: 100px;
  align-self: start;
`;

const Item = styled.li`
  ${TYPO.label}
  margin-bottom: 10px;
  position: relative;
  color: ${COLORS.forest};
  font-feature-settings: var(--font-feature-settings-normal);
  opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};
  transition: 0.4s;
  cursor: pointer;

  ${({ isActive }) =>
    isActive &&
    css`
      &:before {
        content: '';
        position: absolute;
        top: 6px;
        left: -30px;
        display: inline-block;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: ${COLORS.dawn};
      }
    `}
`;

const SideNav = ({ items, activeItem, setActiveItem, ...props }) => {
  return (
    <ContainerSticky {...props}>
      {items.map(({ label, value }) => (
        <Item
          key={value}
          onClick={() => setActiveItem(value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              setActiveItem(value);
            }
          }}
          isActive={value === activeItem}
          tabIndex={0}
        >
          {label}
        </Item>
      ))}
    </ContainerSticky>
  );
};

export default SideNav;
